import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IInventoryTaxListResponse } from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setBatchList, setTaxList } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useInventoryTaxListAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(async (search_keyword?:any,page_size?:number,page_number?:number) => {
    dispatch(
      setLoading({
        key: "isTaxListLoadingInProgress",
        status: true,
      }),
    );
  
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(`${INVENTORY_MODULE?.TAX_LIST?.baseURL}?search_keyword=${search_keyword}&page_number=${page_number}&page_size=${page_size}`, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IInventoryTaxListResponse>) => {
          if (res.data.status === true) {
            dispatch(setTaxList({ data: res.data.data }));
            dispatch(
              setLoading({
                key: "isTaxListLoadingInProgress",
                status: false,
              }),
            );
          } else {
            dispatch(setTaxList({ data: null }));
          }
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config["curlCommand"]);
          dispatch(setTaxList({ data: null }));
          dispatch(
            setLoading({
              key: "isTaxListLoadingInProgress",
              status: false,
            }),
          );
          captureError(e)
        });
    } catch (e: any) {
      dispatch(setTaxList({ data: null }));
      toast.error("Server Error: " + e.message);
    }
  }, [dispatch]);
  return execute;
};
